//分享到网页
import {hasDesktopLicense, hasPremiumLicense, hasPublishLicense} from "../../utils";
import Global from "../../global";
import {getShareDataUrl, isAliOss, uploadCardS3} from "../../api/Aws";
import {getCardDoc, getPublishNoteById} from "../../../model";
import { message } from "antd";
import {noteInfoById, notePublish} from "../../api/api";
import { t } from "i18next";
import {getLanguageCode, isZh} from "@/language";
import {getAllDeeplinks, getDeeplinks} from "@/Utility";

export const shareCardData = async (cardData:any, arrayFiles: any,dialogPublishToWebRef) => {
    if (Global.g_userInfo?.id == undefined) {
        message.error(t("Please login first"));
        return;
    }

    let szId = cardData.id;

    //非publish的证书...
    //也就是只有desktop license的证书..
    let publishNoteInfo: any = null;

    try {//e x 因为有2级域名的关系，后台又是全部改的。这里要先查询一下。
        publishNoteInfo = await noteInfoById(szId, () => {

        }, false);
    } catch (e) {

    }
    if (!hasPublishLicense() && !hasDesktopLicense() && !hasPremiumLicense()) {
        //判断这个有没有发布过...
        if (!publishNoteInfo || !publishNoteInfo?.published) {
            //不能超过20个项目. -- 2024-12-05取消发布数量的限制
            // if (Global.g_userInfo.noteCount > 20 && !DEBUG) {
            //     dialogPublishToWebRef.current?.onCloseIndicator();
            //     message.error(t("PublishMaxCount").replace('{0}', '20'));
            //     return;
            // }
        }
    }

    if (!cardData.doc){
        cardData.doc = await getCardDoc(cardData.id);
    }

    //统计所有的deeplink,上传...
    const arrayDeeplinks = getAllDeeplinks(cardData.doc);
    const arrayLibrarys = [];
    for (let i=0;i<arrayDeeplinks.length;i++){
        const deeplink = decodeDeeplink(arrayDeeplinks[i]);
        if (deeplink.type == 'project'){
            const proj:any = await getProjectById(deeplink.id);
            proj.type = 'project';
            proj.isDeleted = 1;
            arrayLibrarys.push(proj);
        }else if (deeplink.type == 'library'){
            const library:any = await getCardById(deeplink.id);
            library.isDeleted = 1;
            arrayLibrarys.push(library);
        }
    }
    cardData.arrayLibrarys = arrayLibrarys;

    //这里处理需要上传的数据....待更新的？？？
    await uploadCardS3(szId, cardData, arrayFiles);
    let level2Domain = '';
    if (publishNoteInfo){
        level2Domain = publishNoteInfo['二级域名链接'] || ''
    }
    const data = {
        id: szId,
        userId: Global.g_userInfo.id,
        title: cardData.name,
        publishedTitle: cardData.name,
        published: true,
        publishedContent: getShareDataUrl() + szId,
        content: `{type:"card",lang:${getLanguageCode()}}`,
    };
    //分享
    /*
    shareCanvas(data).then(res => {
        message.destroy();
        if (res.code == 0) {
            const szUrl = 'http://106.75.20.145:8809/#draw/' + szProjId;
            if (dialogShareRef != null) {
                dialogShareRef.current.onShareWebFinished(szUrl);
            }
            // clipboard.write(szUrl);
            // message.info("分享地址已复制到剪切板")
        }
    });*/

    const publishNote = await getPublishNoteById(szId);
    const isUpdate = (publishNote != null);
    const isDialogVisible = dialogPublishToWebRef.current?.onIsDialogVisible();
    if (isUpdate && isDialogVisible) {
        message.info(t("Published"));
        // message.info(t("上行流量: "+size));
    }

    //如果是2次改变的。。这个就不重要了。。。
    notePublish(data, () => {
        if (!isUpdate) {
            message.destroy();
            message.error(t("Operator fail"));
        }
    }).then(res => {
        console.log(res);
        let szUrl = res['原始链接'].replace("https://noteey", "https://app.noteey");
        if (isAliOss()){
            szUrl = szUrl.replace('/p/','/cn/p/')
        }

        if (dialogPublishToWebRef != null) {
            dialogPublishToWebRef.current?.onShareWebFinished(szUrl);
        }
        // clipboard.write(szUrl);
        if (!isUpdate && isDialogVisible) {
            message.destroy();
            message.info(t("Published"));
            // message.info(t("上行流量: "+size));
        }


        //发布数量上本地+1
        if (!Global.g_userInfo.noteCount) {
            Global.g_userInfo.noteCount = 0;
        }
        Global.g_userInfo.noteCount = (Global.g_userInfo.noteCount + 1);

    })
}

//测算标题的高度...
export const measureTitleHeight = (szTxt,nWidth)=>{
    const div = document.createElement('div');
    div.className = 'font-weight-600 font-family-medium font-size-15';
    div.innerHTML = szTxt;
    div.style.position = 'fixed';
    div.style.left = '288px';
    div.style.top = '200px';
    div.style.background = '#ff0000';
    div.style.width = `${nWidth}px`;
    document.body.appendChild(div);
    let nHeight = div.offsetHeight;
    document.body.removeChild(div);

    if (nHeight > 40){
        nHeight = 40;
    }
    if (nHeight < 22){
        nHeight = 22;
    }
    return nHeight;
}